/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type CreateSkillRequestBody = {
  /**
   * The complete uploaded SKILL.md content. Handlers enforce a maximum size of 65,536 UTF-8 bytes.
   */
  content: string;
};

/** @internal */
export type CreateSkillRequestBody$Outbound = {
  content: string;
};

/** @internal */
export const CreateSkillRequestBody$outboundSchema: z.ZodMiniType<
  CreateSkillRequestBody$Outbound,
  CreateSkillRequestBody
> = z.object({
  content: z.string(),
});

export function createSkillRequestBodyToJSON(
  createSkillRequestBody: CreateSkillRequestBody,
): string {
  return JSON.stringify(
    CreateSkillRequestBody$outboundSchema.parse(createSkillRequestBody),
  );
}
